export default __webpack_public_path__ + "static/media/admin-created-logo.537f1b4a.svg";